import { render, staticRenderFns } from "./eventStatic.vue?vue&type=template&id=5f27ad96&scoped=true"
import script from "./eventStatic.vue?vue&type=script&lang=js"
export * from "./eventStatic.vue?vue&type=script&lang=js"
import style0 from "./eventStatic.vue?vue&type=style&index=0&id=5f27ad96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f27ad96",
  null
  
)

export default component.exports